import axiosInstance from "../../../helpers/api";

export const getAllTags = (body) => {
  return axiosInstance.get("/superadmin/question-tags", body);
};

export const editTags = (formData) => {
  return axiosInstance.post(
    `/superadmin/question-tags/${formData.id}`,
    formData.formData
  );
};

export const createTags = (formData) => {
  return axiosInstance.post("/superadmin/question-tags", formData);
};

export const deleteTag = (id) => {
  return axiosInstance.delete(`/superadmin/question-tags/${id}`);
};

export const enableTags = (formData) => {
  return axiosInstance.put(
    `/superadmin/question-tags/enable/${formData.id}`,
    formData.formData
  );
};
